/**
 * 公共
 * */
import fly from '../../flyio';

const state = {
  business: [ // 业务
  ],
  userInfo: { // 用户信息
  },
  companyInfo: { // 公司信息
    id: 1
  },
  currentLocation: { // 当前定位信息
    city: null, // 城市
    cityCode: null, // 城市code
    adCode: null, // 区域code
    latitude: null,
    longitude: null
  }
};
const mutations = {
  setUserInfo(state, user) { // 设置 用户信息
    if (user) {
      state.userInfo = user;
    }
  },
  setCompanyInfo(state, company) { // 设置 公司信息
    if (company) {
      state.companyInfo = company;
    }
  },
  setLocation(state, location) { // 设置 当前定位信息
    state.currentLocation.longitude = location.longitude;
    state.currentLocation.latitude = location.latitude;
  },
  setCity(state, city) { // 设置 城市信息
    state.currentLocation.city = city.city;
    state.currentLocation.adCode = city.adCode;
    state.currentLocation.cityCode = city.cityCode;
  }
};

const getters = {
  getBusiness: state => state.business, // 导出业务
  getUserInfo: state => state.userInfo, // 导出用户信息
  getCompanyInfo: state => state.companyInfo, // 导出公司信息
  getLocation: state => state.currentLocation, // 导出当前定位信息
};
const actions = {
  async init({ commit }, params) { // 初始化
  },
  setLocation({ commit }, location) { // 设置当前位置
    commit('setLocation', location);
  },
  setCity({ commit }, city) { // 设置所在城市
    commit('setCity', city);
  },
  setUserInfo({ commit }, user) { // 设置 用户信息
    commit('setUserInfo', user);
  },
  setCompanyInfo({ commit }, company) { // 设置 公司信息
    commit('setCompanyInfo', company);
  }
};
export default {
  name: 'init',
  state,
  mutations,
  getters,
  actions
};



// WEBPACK FOOTER //
// ./src/store/module/init.js